<template>
  <div>
    <div class="checklist-items" v-if="checklist.length > 0">
      <h4>{{ $t('record_show.checklist_items_matched') }}<span class=""> ({{checklist.length}}) </span>
      </h4>
      <div v-show="checklist.length > limit" class="checklist-operations">
        <a href="#" @click="open()">
          {{ $t('header.view_all') }}
        </a>
        <div class="set-data" v-show="show">
          <table class="table checklist-table">
            <thead>
              <tr>
                <th>
                    {{ $t('checklist.headers.document_type') }}
                </th>
                <th>
                    {{ $t('checklist.headers.products') }}
                </th>
                <th>
                  <i @click="close()" class="fas fa-times"></i>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in checklist" :key="item.id" class="list-item">
                <td class="checklist-content-column">
                  <div class="document-type-bubble">{{ item.document_type.name }}</div>
                </td>
                <td class="checklist-content-column" colspan="2">
                  <div class="product-bubble">{{ item.product.name }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="list-wrapper">
        <div class="list" v-html="showChecklistAsList()"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: {
      checklist: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        show: false,
        limit: 10
      }
    },
    methods: {
      open() {
        this.show = true
        this.store.sendMetrics({name: 'checklist_preview', params: this.$route.params, path: this.$route.fullPath})
      },
      close() {
        this.show = false
      },
      showChecklistAsList() {
        return this.checklist.slice(0, this.limit-1).map((item) => {
          return `<span class="list-item">
                    ${''.concat(item.document_type.name, ' / ', item.product.name, ' - ', item.product.code)}
                 </span>`
        }).join('<span class="list-separator">,</span>')
      }
    }
  }
</script>

<style lang="sass" scoped>
.checklist-items
  max-width: 80%
  h4
    font-size: 14px
    font-weight: 500
    letter-spacing: 0.1em
    color: #000
    margin: 10px 0 0 0
  .checklist-operations
    overflow: auto
    .set-data
      box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25)
      background: #fff
      max-width: 60%
      left: 5%
      height: calc(100vh - 200px)
      overflow: auto
      position: absolute
      border: 1px solid #c4c4c4
      border-radius: 3px
      z-index: 100
      .fa-times
        position: absolute
        top: 5px
        right: 20px
        font-size: 20px
        cursor: pointer
        color: #000
  .list-wrapper
    color: inherit
    margin-top: 10px
    ::v-deep
      .list-item
        font-size: 12px
        background: #f8f8f8
        border-radius: 3px
        padding: 5px
        overflow-wrap: break-word
        line-height: 1.9rem
        &:hover
          background: #eee
      .list-separator
        display: inline-flex
        padding: 0 5px
        line-height: 1.9rem
      a
        font-size: 12px
        color: #007bff

.checklist-table
  .checklist-content-column
    top: 0
    white-space: break-spaces
    width: 50%
    font-size: 14px
</style>
